import { jwtDecode } from "jwt-decode";
 
// Retrieve the JWT token from localStorage
const getToken = () => {
  return localStorage.getItem("jwt");
};

// Decodes the JWT token
export const getDecodedToken = () => {
  const token = getToken();
  if (!token) return null;

  try {
    return jwtDecode(token); // Decodes the token
  } catch (error) {
    console.error("Invalid token:", error);
    return null;
  }
};

// Checks if the token is expired
const isTokenExpired = (decodedToken) => {
  return !decodedToken || decodedToken.exp < Date.now() / 1000; // Token is expired if exp < current time
};

// Clears tokens and user data from localStorage
export const clearAuthData = () => { 

  localStorage.removeItem("jwt");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("userData");
};

// Checks if the user is authenticated
export const isAuthenticated = () => {
  const token = getToken();
  
  if (!token) {
    clearAuthData(); // Clear auth data if token is not available
    return false; // User is not authenticated
  }

  const decodedToken = getDecodedToken();
  if (isTokenExpired(decodedToken)) {
    clearAuthData(); // Clear auth data if token is expired
    return false; // User is not authenticated
  }

  return true; // User is authenticated
};

// Retrieve user data stored in localStorage
export const getUserData = () => {
  const userData = localStorage.getItem("userData");
  try {
    return userData ? JSON.parse(userData) : null; // Parse and return userData
  } catch (error) {
    console.error("Invalid user data:", error);
    return null;
  }
};

// Retrieve user roles from userData
export const getUserRoles = () => {
  const userData = getUserData();
  return userData?.role || []; // Return roles or an empty array
};

// Check if the user has a specific role
export const hasRole = (role) => {
  const roles = getUserRoles();
  return roles.includes(role);
};